import { memo } from "react";

const Avatar = memo(({ size = 'md' }: { size?: 'sm' | 'md' }) => (
  <div className={`
    rounded-lg bg-blue-500 flex items-center justify-center
    text-white font-bold shrink-0 select-none
    ${size === 'sm' ? 'w-8 h-8 text-xs' : 'w-9 h-9 text-sm'}
  `}>
    AS
  </div>
));

export default Avatar;